// frontend/src/constants/paymentConstants.js

export const PAYMENT_PROVIDERS = Object.freeze({
  STRIPE: "stripe",
  PAYPAL: "paypal",
  SUMUP: "sumup",
});

export const PAYMENT_PROVIDER_LABELS = Object.freeze({
  [PAYMENT_PROVIDERS.STRIPE]: "Card",
  [PAYMENT_PROVIDERS.PAYPAL]: "PayPal",
  [PAYMENT_PROVIDERS.SUMUP]: "SumUp",
});

export const PAYMENT_CONFIG_REQUEST = "PAYMENT_CONFIG_REQUEST";
export const PAYMENT_CONFIG_SUCCESS = "PAYMENT_CONFIG_SUCCESS";
export const PAYMENT_CONFIG_FAIL = "PAYMENT_CONFIG_FAIL";
export const PAYMENT_CONFIG_RESET = "PAYMENT_CONFIG_RESET";

export const PAYMENT_ORDER_GET_REQUEST = "PAYMENT_ORDER_GET_REQUEST";
export const PAYMENT_ORDER_GET_SUCCESS = "PAYMENT_ORDER_GET_SUCCESS";
export const PAYMENT_ORDER_GET_FAIL = "PAYMENT_ORDER_GET_FAIL";
export const PAYMENT_ORDER_GET_RESET = "PAYMENT_ORDER_GET_RESET";

export const PAYMENT_ORDER_CREATE_REQUEST = "PAYMENT_ORDER_CREATE_REQUEST";
export const PAYMENT_ORDER_CREATE_SUCCESS = "PAYMENT_ORDER_CREATE_SUCCESS";
export const PAYMENT_ORDER_CREATE_FAIL = "PAYMENT_ORDER_CREATE_FAIL";
export const PAYMENT_ORDER_CREATE_RESET = "PAYMENT_ORDER_CREATE_RESET";

export const PAYMENT_ORDER_CANCEL_REQUEST = "PAYMENT_ORDER_CANCEL_REQUEST";
export const PAYMENT_ORDER_CANCEL_SUCCESS = "PAYMENT_ORDER_CANCEL_SUCCESS";
export const PAYMENT_ORDER_CANCEL_FAIL = "PAYMENT_ORDER_CANCEL_FAIL";
export const PAYMENT_ORDER_CANCEL_RESET = "PAYMENT_ORDER_CANCEL_RESET";

export const PAYMENT_ORDER_CONFIRM_REQUEST = "PAYMENT_ORDER_CONFIRM_REQUEST";
export const PAYMENT_ORDER_CONFIRM_SUCCESS = "PAYMENT_ORDER_CONFIRM_SUCCESS";
export const PAYMENT_ORDER_CONFIRM_FAIL = "PAYMENT_ORDER_CONFIRM_FAIL";
export const PAYMENT_ORDER_CONFIRM_RESET = "PAYMENT_ORDER_CONFIRM_RESET";

export const PAYMENT_SET_CURRENT = "PAYMENT_SET_CURRENT";
export const PAYMENT_CLEAR_CURRENT = "PAYMENT_CLEAR_CURRENT";

export const PAYMENT_RESET_ERROR = "PAYMENT_RESET_ERROR";
export const PAYMENT_RESET_META = "PAYMENT_RESET_META";
export const PAYMENT_RESET_STATE = "PAYMENT_RESET_STATE";
